webpackJsonp([70144966829960],{

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(114);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _glamor = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var container = (0, _glamor.css)({
	  maxWidth: '960px',
	  margin: '0 auto',
	  minHeight: '700px',
	  padding: '20px 10px'
	});
	
	var image = (0, _glamor.css)({
	  width: '450px',
	  float: 'left',
	  marginRight: '20px',
	  '@media(max-width: 600px)': {
	    width: '140px'
	  }
	});
	
	var text = (0, _glamor.css)({
	  '@media(max-width: 600px)': {
	    fontSize: '14px',
	    lineHeight: '18px'
	  }
	});
	
	var title = (0, _glamor.css)({
	  '@media(max-width: 600px)': {
	    fontSize: '20px'
	  }
	});
	
	var About = function About(_ref) {
	  var data = _ref.data;
	
	  var page = _.get(data, 'allContentfulPage.edges[0].node');
	  return Glamor.createElement(
	    'div',
	    container,
	    Glamor.createElement('img', _extends({}, image, { src: page.heroImage.responsiveSizes.src, srcSet: page.heroImage.responsiveSizes.srcSet })),
	    Glamor.createElement('p', _extends({}, text, { dangerouslySetInnerHTML: { __html: page.description.childMarkdownRemark.html } }))
	  );
	};
	
	exports.default = About;
	var query = exports.query = '** extracted graphql fragment **';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-82d2ed91aa7d25a2a756.js